import {select as d3select} from 'd3-selection';
import {format as d3format} from 'd3-format';

import * as _ from 'underscore';

import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';
import State from '../State/State';

import './Table.css';


var container = d3select('.WorldMap-table');

var numberFormat = d3format(',');

var getSortSeries = () => {
	switch(State.selectedSeries) {
	case 'cases':
		return 'Cases ETEC and Shigella';

	case 'deaths':
		return State.includeIndirectDeaths ? 'Direct and indirect deaths ETEC and Shigella' : 'Direct deaths ETEC and Shigella';

	case 'dalys':
		return State.includeStunting ? 'DALYs direct and stunting ETEC and Shigella' : 'DALYs direct ETEC and Shigella';

	default:
		return '';
	}
}

var getTitle = () => {
	switch(State.selectedSeries) {
	case 'cases':
		return '10 countries with highest cases...';

	case 'deaths':
		return '10 countries with highest deaths...';

	case 'dalys':
		return '10 countries with highest DALYs...';

	default:
		return '';
	}
}

function getValue(country) {
	var series = getSortSeries();
	var countryData = Model.dataLU[country];
	var value = +countryData[series];

	if(State.selectedSeries === 'dalys' && State.dalysByRate) {
		value = 100000 * value / countryData['Population (<5)'];
	}

	return value;
}

var init = () => {
	Dispatch.dispatch.on('dataReady.Table', update);
	Dispatch.dispatch.on('selectedSeriesUpdate.Table', update);
	Dispatch.dispatch.on('highlightedCountryUpdate.Table', updateHighlight);
	Dispatch.dispatch.on('includeIndirectDeathsUpdate.Table', update);
	Dispatch.dispatch.on('includeStuntingUpdate.Table', update);
	Dispatch.dispatch.on('dalysByRateUpdate.Table', update);
};

var api = {
	init: init
};


function getRate(value, d) {
	return 100000 * value / +d['Population (<5)'];
}

function updateRow(d) {
	var series = getSortSeries();

	d3select(this)
		.select('.WorldMap-table-item-country')
		.text(d.Country);

	d3select(this)
		.select('.WorldMap-table-item-total')
		.text(numberFormat(Math.round(d[series])));

	d3select(this)
		.select('.WorldMap-table-item-rate')
		.text(numberFormat(Math.round(getRate(d[series], d))));

	d3select(this)
		.on('mouseover', (d) => {State.set('highlightedCountry', d.Country);})
		.on('mouseout', (d) => {State.set('highlightedCountry', null);});
}

function updateHighlight() {
	container
		.selectAll('.WorldMap-table-item')
		.classed('highlighted', d => d.Country === State.highlightedCountry);
}

function update() {
	container.select('.WorldMap-table-title')
		.text(getTitle());

	var sorted = _.sortBy(Model.data, d => -getValue(d.Country));
	sorted = sorted.slice(0, 10);

	var u = container
		.select('table tbody')
		.selectAll('tr.WorldMap-table-item')
		.data(sorted);

	u.each(updateRow);
}

export default api;


/** WEBPACK FOOTER **
 ** ./src/Table/Table.js
 **/